export default [
    {
        path: '/WbhQt4MKvu2o9erkEbKC',
        children: [
            {
                path: '8VjtsIMwz9MJ',
                name: 'years-list',
                meta: {
                    title: 'Academic Years',
                    authRequired: true,
                    acc: ['y51976'],
                },
                component: () => import('@/views/year/index'),
            },
            {
                path: '0GsxvNNM4B07',
                name: 'year-new',
                meta: {
                    title: 'New Academic Years',
                    authRequired: true,
                    acc: ['y79288'],
                    breadcrumb: {
                        route: 'years-list'
                    },
                },
                component: () => import('@/views/year/create'),
            },
            {
                path: 'oKHvpFM3OcD3',
                name: 'view-year',
                meta: {
                    title: 'View Academic Year',
                    authRequired: true,
                    acc: ['y63515'],
                    breadcrumb: {
                        route: 'years-list',
                    },
                },
                component: () => import('@/views/year/view'),
            },
            {
                path: 'qbo3ZFiI6k4y',
                name: 'edit-year',
                meta: {
                    title: 'Edit Academic Year',
                    authRequired: true,
                    acc: ['y80877'],
                    breadcrumb: {
                        route: 'years-list'
                    },
                },
                component: () => import('@/views/year/edit'),
            },
            {
                path: "Ve1Gbjrsgy", 
                component: () => import("@/views/year/term/create.vue"),
                name: "create-term",
                meta: {
                    authRequired: true,
                    title: "Create Term",
                    acc: ["y82905"],
                    breadcrumb: {
                        route: 'years-list'
                    }
                },
            },
            {
                    path: "z8aasnhG1LJb/:r?",
                    component: () => import("@/views/year/term/view.vue"),
                    name: "view-term",
                    meta: {
                      authRequired: true,
                      title: "View Term",
                      acc: ["y27202"],
                       breadcrumb: {
                        route: 'years-list'
                    },
                    },
                  },
        ]
    }
]